(ns dashboard.components.radiogroup
  (:require
   [reagent.core :as reagent]
   [re-frame.core :as re-frame]
   [dashboard.utils :refer [cs href]]
   [headlessui-reagent.core :as ui]
   ["@heroicons/react/solid" :refer [CheckCircleIcon]]))

(def zero-width-space-props
  {:dangerouslySetInnerHTML {:__html "&#8203;"}})

(def middot-props
  {:dangerouslySetInnerHTML {:__html "&middot;"}})

(defn radio-group
  [{:keys [selected choices label on-change id-key name-key class]
    :or {on-change identity
         id-key :id
         name-key :name}}]
  [:<>
   [ui/radio-group
    {:value selected
     :on-change on-change
     :class class}
    (when (some? label)
      [:> ui/radio-group-label
       {:class "sr-only"}
       label])
    [:div.space-y-2
     (doall
      (for [choice choices]
        ^{:key (id-key choice)}
        [ui/radio-group-option
         {:value (id-key choice)
          :class (fn [{:keys [active checked]}]
                   (concat [:relative :rounded-lg :shadow-md :px-5 :py-4 :cursor-pointer :flex :focus:outline-none]
                           (when active
                             [:ring-2 :ring-offset-2 :ring-offset-primary-300 :ring-white :ring-opacity-60])
                           (if checked
                             [:bg-primary-50 :text-white]
                             [:bg-white])))}
         (fn [{:keys [active checked]}]
           [:div.flex.items-center.justify-between.w-full
            [:div.flex.items-center
             [:div.text-sm
              [ui/radio-group-label
               {:as :p.font-medium
                :class (if checked :text-white :text-gray-900)}
               (:name choice)]
              [ui/radio-group-description
               {:as :span.inline
                :class (if checked :text-primary-900 :text-gray-500)}
               [:span (:description choice)]]]]
            (when checked
              [:div.flex.shrink-0.text-white
               [:> CheckCircleIcon
                {:class [:w-6 :h-6]}]])])]))]]])

(defn color-circle
  [{:keys [color size] :or {size 8}}]
  [:span.border.border-black.border-opacity-10.rounded-full
   {:aria-hidden true
    :class (str "bg-" color "-500 " "h-" size " w-" size)}])

(defn color-group
  [{:keys [selected colors size label on-change id-key name-key class]
    :or {on-change identity
         id-key :name
         name-key :name
         size 8}}]
  [:<>
   [ui/radio-group
    {:value selected
     :on-change on-change
     :class class}
    (when (some? label)
      [:> ui/radio-group-label
       {:class "sr-only"}
       label])
    [:div.mt-2.flex.items-center
     {:class (if (> size 7)
               "space-x-3"
               "space-x-2")}
     (doall
      (for [color colors]
        ^{:key (:id color)}

        [ui/radio-group-option
         {:value (id-key color)
          :class (fn [{:keys [active checked]}]
                   (cs "-m-0.5 relative p-0.5 rounded-full flex items-center justify-center cursor-pointer focus:outline-none"
                       (when active "ring ring-offset-1 ring-primary-500")
                       (when checked "ring-2 ring-primary-500")))}
         (fn [{:keys [active checked]}]
           [:div
            [:div.flex.items-center
             [:div.text-sm.flex
              [ui/radio-group-label
               {:as :span.sr-only}
               (:name color)]
              [color-circle
               {:color (:name color)
                :size size}]]]])]))]]])
